import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchUser, fetchUsers } from "services/api/users";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { User, UserListPayload, UserListResponse, UserSlice } from "types/users";
import { getErrorMessage, isFresh } from "utils/helpers";

const STALE_TIME = apiConfig.FETCH_USERS.staleTime;

export const fetchUserList = createAsyncThunk<{userList: UserListResponse, page: number}, UserListPayload, {rejectValue: string}>(
    'users/list',
    async ({ page, force = false }, { getState, rejectWithValue }) => {
        const state = getState() as { users: UserSlice, auth: AuthState };
        if (page === 1 && !force && isFresh(state.users.last_fetched_at, STALE_TIME) && !state.users.expired) {
            return rejectWithValue(ERROR.CACHED);
        }
        try {
            const userList = await fetchUsers(state.auth.selectedHubId!, {page});
            return { userList, page };
        } catch (error) {
            return rejectWithValue(ERROR.NOT_FOUND);
        }
    }
);


export const fetchUserData = createAsyncThunk<User, string, {rejectValue: string}>(
    'user/fetch',
    async (id: string, {getState, rejectWithValue}) => {
        const state = getState() as {auth: AuthState};
        try {
            const user = await fetchUser(state.auth.selectedHubId!, id);
            return user;
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
)